import { TimelineItem } from '@/features/timeline';
import { ItemPosition, TimelineItemWithDisplay } from '../../models/timeline-calendar.types';


interface PositionedBaseItem {
  item: TimelineItemWithDisplay;
  position: ItemPosition;
}

interface BaseItemPartitions {
  baseVisibleItemCount: number;
  visibleItems: PositionedBaseItem[];
}

const isPointTimelineItem = (item: TimelineItem): boolean => {
  return !item.endDate;
};

export const partitionBaseItems = (
  positionedBaseItems: PositionedBaseItem[],
): BaseItemPartitions => {
  const visibleItems: PositionedBaseItem[] = [];

  positionedBaseItems.forEach((entry) => {
    if (entry.position.isVisible) {
      visibleItems.push(entry);
    }
  });

  return {
    baseVisibleItemCount: visibleItems.length,
    visibleItems,
  };
};

export const isPointItem = isPointTimelineItem;
